// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96dbc303","453":"3a9a0022","455":"393f0aac","977":"54e6af37"}[chunkId] + ".chunk.js";
};